import React, { useState, useEffect } from 'react'
import { useRovingIndex } from 'roving-ux-react'

const Input = ({ controller, placeholder, urlSearchPage, clearButtonLabel, searchButtonLabel }) => {
  const [state, setState] = useState(controller.state)
  const { roverProps, getTargetProps } = useRovingIndex()

  useEffect(
    () =>
      controller.subscribe(() => {
        setState(controller.state)
      }),
    []
  )

  const redirect = () => (window.location.href = `${urlSearchPage}${state.value}`)

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') redirect()
  }

  const handleClearSearch = () => {
    controller.updateText('')
  }

  const handleInputChange = (e) => {
    controller.updateText(e.target.value)
  }

  const handleSelectSuggestion = (value) => {
    controller.selectSuggestion(value)
    redirect()
  }

  return (
    <>
      <input
        className="search-results__search-box-input"
        value={state.value}
        onChange={handleInputChange}
        onKeyDown={(e) => handleKeyDown(e)}
        aria-label={placeholder}
        placeholder={placeholder}
      />
      {state.suggestions?.length > 0 && state.value && (
        <ul className="search-results__search-box-list" role="menu" {...roverProps}>
          {state.suggestions.map((suggestion, index) => {
            const value = suggestion.rawValue
            return (
              <li
                key={value}
                role="menuitem"
                onClick={() => handleSelectSuggestion(value)}
                onKeyDown={(e) => handleKeyDown(e)}
                {...getTargetProps(index)}
              >
                {value}
              </li>
            )
          })}
        </ul>
      )}
      {state.value.length > 0 && (
        <button
          className="search-results__search-box-clear"
          onClick={() => handleClearSearch()}
          aria-label={clearButtonLabel}
        ></button>
      )}
      <button
        className="search-results__search-box-button"
        onClick={() => redirect()}
        aria-label={searchButtonLabel}
      ></button>
    </>
  )
}

export default Input
